// extracted by mini-css-extract-plugin
module.exports = {"countdown":"xd-z","srOnly":"yd-z"};